import React from 'react';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from 'reactstrap';

import defaultImage from '../../assets/img/components/User/Login/pw-background-plane-shiny.png';
import ResourcesCard from './ResourcesCard';

class ResourcesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latestDropdownOpen: false,
      topicsDropdownOpen: false,
      postsPage: 1,
      selectedLatest: {
        name: 'LATEST',
        id: 0,
      },
      selectedTopic: {
        name: 'ALL TOPICS',
        id: 0,
      },
    };
  }

  handleLatestSelectorClick = () => {
    this.setState({ latestDropdownOpen: !this.state.latestDropdownOpen });
  };

  handleTopicsSelectorClick = () => {
    this.setState({ topicsDropdownOpen: !this.state.topicsDropdownOpen });
  };

  handleOptionClick = (option) => {
    this.props.resetPosts();
    this.setState({ selectedLatest: option });
    this.props.loadPosts(
      1,
      this.props.per_page,
      option.value,
      this.state.selectedTopic.name === 'ALL TOPICS'
        ? []
        : this.state.selectedTopic.id,
    );
    this.setState({ postsPage: 1 });
  };

  handleLoadMore = () => {
    if (this.props.loadMoreState) {
      this.props.loadPosts(
        this.state.postsPage + 1,
        this.props.per_page,
        this.state.selectedLatest.value,
        this.state.selectedTopic.name === 'ALL TOPICS'
          ? []
          : this.state.selectedTopic.id,
      );
      this.setState({ postsPage: this.state.postsPage + 1 });
    }
  };

  handleTopicsClick = (topics) => {
    this.props.resetPosts();
    this.setState({ selectedTopic: topics });
    this.props.loadPosts(
      1,
      this.props.per_page,
      this.state.selectedLatest.value,
      topics.name === 'ALL TOPICS' ? [] : topics.id,
    );
    this.setState({ postsPage: 1 });
  };

  renderOptionsSelector = () => (
    <div className="field">
      <Dropdown
        isOpen={this.state.latestDropdownOpen}
        toggle={this.handleLatestSelectorClick}
        className="my-profile-selector"
      >
        <DropdownToggle className="my-profile-dropdown-toggle">
          <span className="option-title">{this.state.selectedLatest.name}</span>

          {this.state.latestDropdownOpen ? (
            <i className="icon-expand select-icon rotate down" />
          ) : (
            <i className="icon-expand select-icon rotate" />
          )}
        </DropdownToggle>

        <DropdownMenu>
          {this.props.selectOrderOptions.map((option) => (
            <DropdownItem
              className="drop-item"
              key={option.id}
              onClick={() => this.handleOptionClick(option)}
            >
              {option.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );

  renderTopicsSelector = () => (
    <div className="field">
      <Dropdown
        isOpen={this.state.topicsDropdownOpen}
        toggle={this.handleTopicsSelectorClick}
        className="my-profile-selector"
      >
        <DropdownToggle className="my-profile-dropdown-toggle">
          <span className="option-title">{this.state.selectedTopic.name}</span>

          {this.state.topicsDropdownOpen ? (
            <i className="icon-expand select-icon rotate down" />
          ) : (
            <i className="icon-expand select-icon rotate" />
          )}
        </DropdownToggle>

        <DropdownMenu>
          {this.props.categories.map((option) => (
            <DropdownItem
              className="drop-item"
              key={option.id}
              onClick={() => this.handleTopicsClick(option)}
            >
              {option.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );

  UNSAFE_componentWillMount() {
    this.props.loadCategories();
    this.props.loadPosts(
      1,
      this.props.per_page,
      this.state.selectedLatest.value,
    );
    this.props.loadFeaturedBlog();
  }

  componentWillUnmount() {
    this.props.resetPosts();
    this.props.resetCategories();
  }

  render() {
    return (
      <div className="resources-container">
        <div className="top-row mr-0 ml-0 pr-0 pl-0 pr-md-4 pl-md-4">
          <div className="card-gradient">
            <a
              className="w-100"
              target="_blank"
              rel="noopener noreferrer"
              href={
                this.props.featuredBlog && this.props.featuredBlog[0].link
                  ? this.props.featuredBlog[0].link
                  : '#'
              }
            >
              <div
                className="top-banner d-flex flex-column"
                height="352"
                width="1601"
                style={{
                  backgroundImage:
                    this.props.featuredBlog &&
                    this.props.featuredBlog[0].featured_media &&
                    this.props.featuredBlog[0].featured_media !== null &&
                    this.props.featuredBlog[0].featured_media !== 0
                      ? `url(${this.props.featuredBlog[0]._embedded['wp:featuredmedia'][0].source_url})`
                      : `url(${defaultImage})`,
                }}
              >
                <div className="title pt-4 pl-4">FEATURED BLOG</div>
                <div className="bottom-title mt-auto">
                  {this.props.featuredBlog && this.props.featuredBlog[0].title
                    ? this.props.featuredBlog[0].title.rendered
                    : 'Featured blog'}
                </div>
              </div>
            </a>
          </div>
        </div>

        <Row className="mr-0 ml-0 pr-4 pl-4 align-items-center mb-5">
          <div className="blogs-title mb-3 mb-md-0">Blogs</div>
          <Col
            sm={4}
            md={4}
            lg={4}
            xl={2}
            className="pl-0 pr-0 mb-3 mb-sm-0 mr-sm-4"
          >
            {this.renderOptionsSelector()}
          </Col>
          <Col sm={4} md={4} lg={4} xl={2} className="pl-0 pr-0">
            {this.renderTopicsSelector()}
          </Col>
        </Row>

        <Row className="mr-0 ml-0 pr-4">
          {this.props.posts.map((item) => (
            <Col
              xs={12}
              sm={6}
              md={6}
              lg={4}
              className="pl-4 pr-0 mb-4"
              key={item.id}
            >
              <ResourcesCard item={item} key={item.id} />
            </Col>
          ))}
          <Col xs={12} className="text-center">
            {this.props.isLoading && (
              <button className="btn btn-outline-secondary btn-lg disabled">
                LOADING...
              </button>
            )}
            {this.props.loadMoreState && !this.props.isLoading && (
              <button
                onClick={this.handleLoadMore}
                className="btn btn-outline-secondary btn-lg"
              >
                LOAD MORE
              </button>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default ResourcesView;
